import { STATUS_TYPE } from '../../../enum';
import { PropertyCategory } from '../../propertyCategory/api/interface';
import { PropertySubCategory } from '../../propertySubCategory/api/interface';

export interface FeatureItems {
  featureId: string;
  value: string;
}
export interface Attachments {
  fileName: string;
  id: string;
  fileType: string;
  key: string;
  url?: string;
}

export interface PropertyFacilityMapper {
  advertiseId: string;
  facilityId: string;
  id: string;
  isAvailable: boolean;
  property_facility: {
    id: string;
    labelAr: string;
    labelEn: string;
  }
}

export interface PropertyFeatureMapper {
  advertiseId: string;
  featureId: string;
  id: string;
  value: string;
  property_feature: {
    id: string;
    labelAr: string;
    labelEn: string;
  }
}

export interface GetAdvertise {
  id: string;
}

export interface FindAdvertise {
  status?: string;
  search?: string;
  limit?: number;
  skip?: number;
  isExport?: boolean;
  isDraftIncluded?: boolean;
  sortByName?: string;
  sortByOrder?: string;
  adType?: string; // "company", "agent", or "all" - for company role filtering
}

export interface CreatePatchAdvertise {
  id?: string;
  title: string;
  areaPolygon?: string;
  description: string;
  zipCode: string;
  zoneNumber: string;
  streetNumber: string;
  buildingNumber: string;
  address: string;
  latitude: number;
  longitude: number;
  possessionTypeId: string;
  rentFrequency: string;
  price: string;
  // sizeSqft: string;
  // startDate: Date;
  // endDate: Date;
  status: string;
  // rejectionReason: string;
  locationId: string;
  categoryId: string;
  subCategoryId: string;
  userId: string;
  // packageId: string;
  attachmentArray: string[];
  propertyFacilityIds: string[];
  propertyFeatureItems: FeatureItems[];
  titleDeedAssetId?: string;
  individualIdAssetId?: string;
  isApproximateLocation?: boolean;
}

export interface Advertise {
  id: string;
  title: string;
  possessionTypeId: string;
  advertiseNumber: string;
  description: string;
  zoneNumber: string;
  streetNumber: string;
  buildingNumber: string;
  zipCode: string;
  address: string;
  latitude: number;
  longitude: number;
  possessionType: string;
  rentFrequency: string;
  price: string;
  sizeSqft: string;
  startDate: Date;
  endDate: Date;
  status: string;
  rejectionReason: string;
  categoryId: string;
  subCategoryId: string;
  packageId: string;
  attachmentArray: string[];
  property_category: PropertyCategory;
  property_sub_category: PropertySubCategory;
  property_possession_type: {
    id: string;
    labelEn: string;
    labelAr: string;
  }
  attachments: Attachments[];
  advertise_property_facility_mappers: PropertyFacilityMapper[];
  advertise_property_feature_mappers: PropertyFeatureMapper[];
  createdByUser: {
    id: string;
    name: string;
    userRole?: string;
  }
  location_management: {
    id?: string;
    code: string;
    labelEn: string;
    labelAr: string;
  }
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
  titleDeed?: Attachments | null;
  individualID?: Attachments | null;
}

interface InitialState {
  data: Advertise[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
